import { render, staticRenderFns } from "./RadioboxMarked.vue?vue&type=template&id=3ebe8680"
import script from "./RadioboxMarked.vue?vue&type=script&lang=js"
export * from "./RadioboxMarked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports